/**
 * 데이터 형식
{
  date: '', //YYYY-MM-DD
  items: [ // 변경 유형 별 객체 배열
    {
      type: '', // 변경 유형(신규/버전 추가: 'Added', 변경: 'Changed', 버그 수정: 'Fixed', 미지원: 'Removed', 문서 수정:'Docs')
      summary: <></>, // 변경 내용 요약
      apis: [ // 변경 유형에 해당하는 API 배열, 변경사항이 전체 적용인경우(ex.에러 응답 포맷 변경) 빈배열도 가능
          {
            authorized_sol_ser: '',  // 권한별 노출, 필요없다면 제거 (주문금액분할모듈업체: 'cal_state_per_prod')
            method: '',
            action: '',
            detail: <></> // API 별 상세 설명, 필요없다면 제거
          }
      ]
    },
  ]
}
*/

const release2026 = [
  {
    date: '2026-04-22',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          [재고/SKU상품 등록] 바코드 입력 허용 문자 범위 확대
        </>,
        apis: [
          {
            method: 'POST',
            action: '/stock/add/v1.2',
            detail:
            <>
              - <strong>기존</strong> : 영문, 숫자, 띄어쓰기, _만 입력 가능<br/>
              - <strong>변경</strong> : 영문, 숫자, 띄어쓰기와 특수문자 ( ) - _ = + . / , 도 입력 가능<br/>
            </>
          }
        ]
      }
    ]
  },
  {
    date: '2026-04-20',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          주문상태변경 API 상태 변경 가능 조건 확장
        </>,
        apis: [
          {
            method: 'PATCH',
            action: '/orders/status',
            detail:
            <>
              - <strong>취소요청</strong> : 현재 주문상태가 [주문재확인]인 경우 변경 가능<br/>
              - <strong>취소완료</strong> : 현재 주문상태가 [주문재확인, 취소요청]인 경우 변경 가능<br/>
            </>
          }
        ]
      }
    ]
  },
  {
    date: '2026-04-13',
    items: [
      {
        type: 'Added',
        summary:
        <>
          입출고 내역 조회 추가
        </>,
        apis: [
          {
            method: 'POST',
            action: '/stocks/inout',
            detail:
            <>
              <strong>입출고 내역 조회 추가</strong><br/>
            </>
          }
        ]
      }
    ]
  },
  {
    date: '2026-04-03',
    items: [
      {
        type: 'Changed',  
        summary:
        <>
          주문리스트 조회 API Response 내 오늘출발 주문 여부 <code>is_send_today</code> 추가<br/>
          - 지원 쇼핑몰: 쿠팡, 옥션, 지마켓, 11번가
        </>,
        apis: [
          {
            method: 'POST',
            action: '/orders',
          },
        ]
      }
    ]
  },
  {
    date: '2026-03-31',
    items: [
      {
        type: 'Changed',  
        summary:
        <>
          상품리스트 조회/상세조회/상품등록/수정 API 파라미터에 아래 필드 추가 <br /><br /> - 단위 가격 표시 여부 <code>unit_price_yn</code>,<br />
          - 단위 가격 총 용량 <code>total_capacity</code>,<br /> - 단위 가격 표시 용량 <code>unit_capacity</code>,<br /> - 단위 가격 표시 단위 <code>indication_unit</code>
        </>,
        apis: [
          {
            method: 'POST',
            action: 'product/online/list/v1.2',
          },
          {
            method: 'GET',
            action: '/products/:ol_shop_no/v1.2',
          },
          {
            method: 'POST',
            action: '/products/add/v1.2',
          },
          {
            method: 'PUT',
            action: '/products/edit/v1.2',
          }
        ]
      }
    ]
  },
  {
    date: '2026-03-30',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          데이터 정확성 유지 및 정책 기준 반영 위해
          주문 리스트 조회 & 주문 상세 조회 API 응답값 내 국내 주문 가격 반올림 처리 및 클레임 주문 건 가격 & 출고 수량 등 값 변경
        </>,
        apis: [
          {
            method: 'POST',
            action: '/orders',
            detail:
            <>
              <strong>주문리스트 조회 시</strong><br/>
              - results 내 <code>sales ship_cost shop_cost_price shop_supply_price pay_amt discount_amt shop_discount seller_discount coupon_discount point_discount</code> 해당 필드 반올림 제거<br/>
              <strong>클레임 주문 건 ('취소완료', '반품완료', '교환완료', '맞교환완료') 일 경우</strong><br/>
              - results 내 <code>sale_cnt sales shop_supply_price shop_cost_price ship_cost pay_amt discount_amt out_cnt pack_unit</code> 0 처리<br/>
              - results_prod 내 <code>opt_sale_cnt</code> 0 처리<br/>
            </>
          },
          {
            method: 'GET',
            action: '/order/:uniq',
            detail:
            <>
              <strong>주문 상세 조회 시</strong><br/>
              - order_data 내 <code>sales ship_cost shop_cost_price shop_supply_price pay_amt discount_amt shop_discount seller_discount coupon_discount point_discount sale_price</code> 해당 필드 반올림 제거<br/>
              <strong>클레임 주문 건 ('취소완료', '반품완료', '교환완료', '맞교환완료') 일 경우</strong><br/>
              - order_data 내 <code>sale_cnt sales shop_supply_price shop_cost_price ship_cost pay_amt discount_amt out_cnt pack_unit</code> 0 처리<br/>
              - prod_list 내 <code>opt_sale_cnt</code> 0 처리<br/>
              - ord_opt_list 내 <code>opt_sale_cnt sale_price</code> 0 처리<br/>
            </>
          }
        ]
      }
    ]
  },
  {
    date: '2026-03-17',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          주문 리스트 조회 API 파라미터 <code>fulfillment_type</code> 추가
        </>,
        apis: [
          {
            method: 'POST',
            action: '/orders',
            detail:
            <>
              - 기존 <code>fulfillment_yn</code>(boolean)으로는 물류/일반 통합 조회가 불가했던 점을 개선하여 <code>fulfillment_type</code> 파라미터를 신설<br/>
              - <code>fulfillment_type: "all"</code> 입력 시 물류 배송 + 일반 배송 주문을 모두 조회 가능<br/>
              - 기존 <code>fulfillment_yn</code>은 하위 호환을 위해 유지, <code>fulfillment_type</code> 입력 시 <code>fulfillment_type</code>이 우선 적용됨<br/>
              - 응답값에 <code>ship_type</code> 필드 추가 (<code>물류배송</code> / <code>일반배송</code> / <code>배송없음</code>)
            </>
          }
        ]
      }
    ]
  },
  {
    date: '2026-02-25',
    items: [
      {
        type: 'Changed',  
        summary:
        <>
          SKU상품-리스트 조회/상세조회/등록, 세트상품-조회/등록 API 파라미터 출고 리드타임 <code>out_leadtime</code> 추가
        </>,
        apis: [
          {
            method: 'POST',
            action: '/stock/set-add',
          },
          {
            method: 'POST',
            action: '/stock/sets',
          },
          {
            method: 'POST',
            action: '/stock/add',
          },
          {
            method: 'GET',
            action: '/stock/:sku_cd',
          },
          {
            method: 'POST',
            action: '/stock/list',
          }
        ]
      }
    ]
  },
  {
    date: '2026-02-12',
    items: [
      {
        type: 'Changed',
        summary: 
        <>
          주문 리스트조회 API Response 귀책 구분 <code>claim_fault_type</code> 추가
        </>,
        apis: [
          {
            method: 'POST',
            action: '/orders',
          }
        ]
      }
    ]
  },
  {
    date: '2026-02-11',
    items: [
      {
        type: 'Added',
        summary:
        <>
          선택작업 등록 API v1.1 추가
        </>,
        apis: [
          {
            method: 'POST',
            action: '/work/addWorkSelect/v1.1',
            detail: 
            <>
              v1.0 버전과의 차이점<br/>
              - 쇼핑몰 상품 연동 작업시 호출하는 파라미터에 <code>shop_cd, shop_id, std_ol_yn</code> 제거.<br/>
              - 쇼핑몰 상품 연동 작업시 list 파라미터에 <code>c_sale_cd</code> 가 아닌 <code>ol_shop_no</code> 사용<br/>
              - 나머지는 v1.0 과 동일
            </>
          }
        ]
      }
    ]
  },
  {
    date: '2026-02-02',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          배송정보 업데이트 API 파라미터 검증 강화
        </>,
        apis: [
          {
            method: 'PUT',
            action: '/order/setInvoice',
            detail:
            <>
              - 배송정보 업데이트 API 요청 시 orders 내부 타입이 유효하지 않은 경우 오류가 반환되도록 개선되었습니다.
            </>
          }
        ]
      }
    ]
  },
  {
    date: '2026-01-21',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          주문상태변경 API 상태 변경 가능 조건 확장
        </>,
        apis: [
          {
            method: 'PATCH',
            action: '/orders/status',
            detail:
            <>
              - <strong>배송중</strong> : 현재 주문상태가 [주문재확인, <strong>출고완료</strong>]인 경우 변경 가능<br/>
            </>
          }
        ]
      }
    ]
  }
]

export default release2026;